import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TxStatus } from '@/entities';

export interface TxModalState {
  isOpen: boolean;
  status: TxStatus;
}

const initialState: TxModalState = {
  isOpen: false,
  status: 'error'
};

const txModalSlice = createSlice({
  name: 'txModal',
  initialState,
  reducers: {
    openTxModal: (state, action: PayloadAction<{ status?: TxStatus } | undefined>) => {
      state.isOpen = true;
      state.status = action?.payload?.status ?? 'processing';
    },
    setTxStatus: (state, action: PayloadAction<TxStatus>) => {
      state.status = action.payload;
    },
    closeTxModal: (state) => {
      state.isOpen = false;
    }
  }
});

export const { openTxModal, setTxStatus, closeTxModal } = txModalSlice.actions;
export default txModalSlice.reducer;
